// eslint-disable-next-line import/prefer-default-export
export function state() {
  return {
    contentTags: false,
  };
}
